import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WBSButton } from '@/common/WBSButton';
import FollowUpNetworkTable from '@/tables/FollowUpNetworkTable';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-network/')({
  component: FollowUpNetworkScreen,
});

/**
 * The Follow-up Network directory list, with a single link to the map, as in
 * legacy. A bare `Title`: legacy has no help placement on this heading.
 */
function FollowUpNetworkScreen() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <Title>{t('wbs.follow-up-network')}</Title>
        <WBSButton as={Link} to="/follow-up-network/map" wide>
          {t('wbs.view-map')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpNetworkTable />
    </PageContainer>
  );
}
